import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import {
  BANKS,
  DOCUMENT_TYPES_MARRIAGE_CONTRACT,
  DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import isFileSizeSmallerThan from '../../../../utils/validateFileSize';

const NotarialDocuments = ({ backHandler, loading, deal, chosenBankAppealId, setLoading, onSuccess, bankId }) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();

  const onNotarialDocumentsSubmit = async (values) => {
    if (bankId == BANKS.EURAZ) {
    } else {
      if (!values['согласие']) {
        alert.error('Необходимо загрузить согласие супруга (супруги) на внесудебную реализацию авто');
        return;
      }

      if (!isFileSizeSmallerThan(values['согласие'], 5)) {
        alert.error('Размер файла согласия супруга (супруги) не должен превышать 5 МБ');
        return;
      }
    }

    const filesToUpload = [
      values['согласие'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_SPOUSE_CONSENT, file: values['согласие'] },
      values['доверенность'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_POWER_OF_ATTORNEY, file: values['доверенность'] },
      values['Заявление на внесудебную реализацию авто'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE, file: values['Заявление на внесудебную реализацию авто'] },
      values['Брачный контракт'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_MARRIAGE_CONTRACT, file: values['Брачный контракт'] },
    ].filter(Boolean);

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);

      if (bankId != BANKS.FORTE) {
        sendMarriedDoc({ appealId: chosenBankAppealId })
          .then(() => {
            onSuccess(values);
          })
          .catch(() => {
            alert.error('Не удалось отправить согласие супруга (супруги) на внесудебную реализацию авто');
            setLoading(false);
          });
      } else {
        onSuccess(values);
      }
    } catch (err) {
      alert.error('Ошибка загрузки документов');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'Документы'}
        hint="Проконсультируйте клиента какие именно доверенности и согласия надо сделать. Нужно чтобы клиент запрашивал равнозначность доверенности, это необходимо для того, чтобы можно было выписать доверенность у любого нотариуса.   Так же нужно описать на кого нужно сделать доверенность на постановку на учет. Выписать доверенность на регистрационные действия нужно на ФИО, ИИН человека."
        grid={{ display: 'grid', gap: 20 }}
        action={'Сохранить и продолжить'}
        inputs={[
          {
            text: 'Согласие супруга (супруги) на внесудебную реализацию авто',
            label: 'Загрузить документ',
            name: 'согласие',
            id: 'Согласие супруга (супруги) на внесудебную реализацию авто',
            component: DocsInputNew,
            required: true,
          },
          {
            text: 'Заявление на внесудебную реализацию авто',
            label: 'Загрузить документ',
            name: 'Заявление на внесудебную реализацию авто',
            id: 'Заявление на внесудебную реализацию авто',
            component: DocsInputNew,
          },
          {
            text: 'Брачный контракт',
            label: 'Загрузить документ',
            name: 'Брачный контракт',
            id: 'Брачный контракт',
            component: DocsInputNew,
          },
          {
            text: 'Доверенность постановки на учет',
            label: 'Загрузить документ',
            name: 'доверенность',
            id: 'Доверенность постановки на учет',
            component: DocsInputNew,
          },
          {
            label: 'Номер доверенности',
            name: 'powerOfAttorneyNumber',
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default NotarialDocuments;
